export default __webpack_public_path__ + "static/media/EP18_ERYTHREE.0e67efbf.mp3";